import request from "./api";

export class FixtureService {
    async createFixtureRoom(fixtureId: string) {
        const response = await request({
            method: "POST",
            url: `api/fixturerooms/create/${fixtureId}`,
            data: {},
        });

        return response;
    }

    async getFixtureList() {
        const response = await request({
            method: "GET",
            url: `api/fixtures/list`,
        });

        return response;
    }

    async getTrainingFixturesList() {
        const response = await request({
            method: "GET",
            url: `api/fixtures/training/list`,
        });

        return response;
    }

    async getFixturesWithVideoDropdownList() {
        const response = await request({
            method: "GET",
            url: `api/fixtures/dropdown-list/with-video`,
        });

        return response;
    }

    async getExternalEvents(fixtureId: string) {
        const response = await request({
            method: "GET",
            url: `api/fixtures/${fixtureId}/externalevents`,
        });

        return response;
    }

    async createTrainingFixture(trainingName: string, selectedFixtureId: number) {
        const response = await request({
            method: "POST",
            url: `api/fixtures/training/create`,
            data: {
                trainingName,
                bureauMatchId: selectedFixtureId,
            },
        });

        return response;
    }

    async updateFixtureBureauId(fixtureId: string, bureauId: number) {
        const response = await request({
            method: "PUT",
            url: `/api/fixtures/${fixtureId}/updatebureauid`,
            data: {bureauId},
        });
        return response;
    }

    static get instance() {
        return fixtureService;
    }
}

const fixtureService = new FixtureService();

export default fixtureService;
